export var ExportFormat;
(function (ExportFormat) {
    ExportFormat["Csv"] = "csv";
    ExportFormat["ZippedPdf"] = "zippedPdf";
    ExportFormat["Pdf"] = "pdf";
})(ExportFormat || (ExportFormat = {}));
export var DownloadMode;
(function (DownloadMode) {
    DownloadMode["Bulk"] = "bulk";
    DownloadMode["Single"] = "single";
})(DownloadMode || (DownloadMode = {}));
export var DownloadScope;
(function (DownloadScope) {
    DownloadScope["Portfolio"] = "portfolio";
    DownloadScope["Community"] = "community";
    DownloadScope["Report"] = "report";
})(DownloadScope || (DownloadScope = {}));
export var ExportStatus;
(function (ExportStatus) {
    ExportStatus["Idle"] = "idle";
    ExportStatus["Preparing"] = "preparing";
    ExportStatus["Success"] = "success";
    ExportStatus["Error"] = "error";
})(ExportStatus || (ExportStatus = {}));
export var ExportErrorReason;
(function (ExportErrorReason) {
    ExportErrorReason["Generic"] = "generic";
    ExportErrorReason["NothingToExport"] = "nothingToExport";
})(ExportErrorReason || (ExportErrorReason = {}));
export var ExportKind;
(function (ExportKind) {
    ExportKind["Reports"] = "reports";
    ExportKind["Recommendations"] = "recommendations";
    ExportKind["Portfolio"] = "portfolio";
})(ExportKind || (ExportKind = {}));
